export default __webpack_public_path__ + "static/media/element_spec_8.b97a72e1.webp";